import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import CustomButton from '../../../../../../components/buttons/CustomButton';
import useSubscriptionFeatures from '../../../../../../hooks/useSubscriptionFeatures';
import { SUBSCRIPTION_PERMISSIONS } from '../../../../../../consts/SubscriptionFeatures';

/**
 * "Vender pacote": o mesmo botão no cabeçalho da seção e no estado vazio.
 * Com o plano sem pacotes ele mostra o cadeado, mas continua clicável: o
 * `PackagePurchaseFlow` abre o modal de upgrade no lugar da lista.
 */
function WalletPurchaseButton({ onClick, label = 'Vender pacote', style = 'main' }) {
  const { hasPermission } = useSubscriptionFeatures();
  const locked = !hasPermission(SUBSCRIPTION_PERMISSIONS.SERVICE_PACKAGES);

  return (
    <CustomButton
      style={style}
      variant="contained"
      icon={locked ? <LockOutlinedIcon fontSize="small" /> : <AddIcon fontSize="small" />}
      label={label}
      onClick={onClick}
    />
  );
}

export default WalletPurchaseButton;
